import {
  box as iconBox,
} from '@wordpress/icons';

if (typeof wp.data != 'undefined' && typeof wp.blocks != 'undefined') {

// Container Block

(function(wp) {
  var el = wp.element.createElement;
  let registerBlockType = wp.blocks.registerBlockType;
  var useBlockProps = wp.blockEditor.useBlockProps;
  var InnerBlocks = wp.blockEditor.InnerBlocks;

  registerBlockType('theme/container', {
    title: 'Container',
    category: 'design',
    icon: iconBox,
    edit: function(props) {
      // let blockProps = useBlockProps();

      // if (typeof props.className === 'undefined') {
      //   props.className = '';
      // }

      return el('div', props,
        el(InnerBlocks)
      )
    },
    save: function() {
      let blockProps = useBlockProps.save();

      return el('div', blockProps,
        el(InnerBlocks.Content)
      )
    }
  } );
})(window.wp);

}